import { axiosbaseurl } from "configure"
import { createContext, useContext, useEffect, useState } from "react"
import secureLocalStorage from "react-secure-storage"
import React from "react"
const RolesContext = createContext()

export const usePermissionData = () => {
  return useContext(RolesContext)
}

export const PermissionContext = ({ children }) => {
  const [permissions, setPermisssions] = useState([])
  const [loginStatus, setLoginStatus] = useState(false)

  useEffect(() => {
    const token = secureLocalStorage.getItem("token")
    setLoginStatus(token ? true : false)
  }, [])

  useEffect(() => {
    const token = secureLocalStorage.getItem("token")

    function getRoles() {
      axiosbaseurl
        .get(`/roles-and-permission/employee/role`)
        .then(res => {
          const roles = JSON.parse(res.data.data?.permissions)

          const final_data = roles.map(item => {
            const [module_id, view, add, edit, remove] = item
              .split(",")
              .map(i => Number(i))
            return { module_id, view, add, edit, remove }
          })

          setPermisssions(final_data)
          // console.log('rolePermission', res.data.data.permission)
        })
        .catch(err => console.log(err))
    }

    if (loginStatus && token) getRoles()
  }, [loginStatus])

  const checkAccess = (mod_id, type) => {
    // console.log(permissions)
    return permissions?.some(
      temp => temp.module_id == mod_id && temp[type] == 1
    )
  }

  return (
    <RolesContext.Provider value={{ checkAccess, permissions, setLoginStatus }}>
      {children}
    </RolesContext.Provider>
  )
}
